import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CotizacionesComponent } from './cotizaciones.component';
import { TiposCondicionComponent } from './tipos-condicion/tipos-condicion.component';
import { TiposPagoComponent } from './tipos-pago/tipos-pago.component';
import { TiposImpuestoComponent } from './tipos-impuesto/tipos-impuesto.component';
import { TiposValidezComponent } from './tipos-validez/tipos-validez.component';
import { TiposMonedaComponent } from './tipos-moneda/tipos-moneda.component';
import { TiposGarantiaComponent } from './tipos-garantia/tipos-garantia.component';
import { TiposEntregaComponent } from './tipos-entrega/tipos-entrega.component';
import { TiposPlazoComponent } from './tipos-plazo/tipos-plazo.component';
import { CompetidoresComponent } from './competidores/competidores.component';

const routes: Routes = [
    {
        path: '',
        component: CotizacionesComponent
    },
    {
        path: 'cotizacion-detalle/:id',
        loadChildren: 'app/pages/logueado/cotizaciones/detalle-cotizacion-pagina/detalle-cotizacion-pagina.module#DetalleCotizacionPaginaModule'
    },
    {
        path: 'cotizacion-imprimir/:id',
        loadChildren: 'app/pages/logueado/cotizaciones/imprimir-cotizacion-pagina/imprimir-cotizacion-pagina.module#ImprimirCotizacionPaginaModule'
    },
    {
        path: 'tipos-pago',
        component: TiposPagoComponent
    },
    {
        path: 'tipos-impuesto',
        component: TiposImpuestoComponent
    },
    {
        path: 'tipos-validez',
        component: TiposValidezComponent
    },
    {
        path: 'tipos-moneda',
        component: TiposMonedaComponent
    },
    {
        path: 'tipos-plazo',
        component: TiposPlazoComponent
    },
    {
        path: 'tipos-garantia',
        component: TiposGarantiaComponent
    },
    {
        path: 'tipos-entrega',
        component: TiposEntregaComponent
    },
    {
        path: 'tipos-condicion',
        component: TiposCondicionComponent
    },
    {
        path: 'competidores',
        component: CompetidoresComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CotizacionesRoutingModule { }